module.exports = __webpack_public_path__ + "static/media/passportToken.81fbe922.svg";